import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import PositionCard from './PositionCard'

const DepartmentColumn = ({ 
  department, 
  selectedPosition, 
  highlightedPositions, 
  onPositionClick,
  index,
  searchTerm = '' // Добавляем поисковый запрос для отображения правильного счетчика
}) => {
  // Анимация для колонки
  const columnVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  }

  return (
    <motion.div
      variants={columnVariants}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-3 sm:p-4"
    >
      {/* Заголовок отдела */}
      <div className="mb-4 pb-3 border-b border-gray-100">
        <div className="flex items-center space-x-3 mb-2">
          {/* Цветовой индикатор отдела */}
          <div 
            className="w-4 h-4 rounded-full flex-shrink-0"
            style={{ backgroundColor: department.color || '#3B82F6' }}
          />
          <h3 className="font-semibold text-gray-800 text-base sm:text-sm leading-tight">
            {department.name}
          </h3>
        </div>
        <p className="text-sm sm:text-xs text-gray-500 mt-1">
          {department.positions?.length || 0} должност{(department.positions?.length || 0) === 1 ? 'ь' : (department.positions?.length || 0) < 5 ? 'и' : 'ей'}
          {searchTerm && <span className="text-blue-600"> (найдено)</span>}
        </p>
      </div>

      {/* Должности в отделе */}
      <div className="space-y-2 sm:space-y-3">
        <AnimatePresence initial={false}>
          {(department.positions || []).map((position, positionIndex) => (
            <PositionCard
              key={position.id}
              position={position}
              isSelected={selectedPosition?.id === position.id}
              isHighlighted={highlightedPositions.includes(position.id)}
              onClick={() => onPositionClick(position)}
              index={positionIndex}
            />
          ))}
        </AnimatePresence>
      </div>
    </motion.div>
  )
}

export default DepartmentColumn 